import cx from 'classnames'
import type React from 'react'

import css from './Tooltip.module.scss'
import type { Classnames, Props } from './types'

const Tooltip: React.FC<Props> = ({
  children,
  content,
  wrap = false,
  position = 'bottom',
  autoWidth = false,
  spacing = 'sm',
  className,
  nodeClassName,
  tooltipClassName,
  onClick,
  onMouseUp,
  // @ts-expect-error
  containerRef,
  // @ts-expect-error
  disabled,
}) => {
  const classes: Classnames = {
    container: cx(css.container, className),
    nodeInner: cx(nodeClassName, css.flex, { [css.disabled]: disabled }),
    nodeOuter: cx(css.node, css.flex),
    tooltip: cx(
      css.tooltip,
      tooltipClassName,
      {
        [css.wrap]: wrap,
        [css.noWrap]: !wrap,
        [css.autoWidth]: autoWidth,
      },
      position && css[position],
      css[spacing]
    ),
  }

  return (
    <div className={classes.container} ref={containerRef}>
      <div className={classes.nodeOuter} onMouseUp={onMouseUp}>
        <div className={classes.nodeInner} onClick={onClick}>
          {children}
        </div>
      </div>

      {content !== null && <div className={classes.tooltip}>{content}</div>}
    </div>
  )
}

export default Tooltip
